import React from 'react';
import BasicModal from '../../components/Modals/BasicModal';

const VehiclePagecard5 = (props) => {
    return (
        <div className=" md:w-full border-x border-b border-gray-300 shadow-md h-[230px] bg-white rounded-md mt-1">
            <div className="flex w-full justify-between  bg-[#2374BF] text-white pl-2 p-1  rounded-t-lg font-semibold text-md">
                <p className="">{props.heading}</p>

                {/* Trigger button/icon */}
                {props.trigger && (
                    <div onClick={props.handleOpenModal} className=" flex  font-thin  gap-1 cursor-pointer ">
                        Click for Driver Details {props.trigger}

                    </div>
                )}

                {/* Modal */}
                <BasicModal
                    open={props.open}
                    handleOpenModal={props.handleOpenModal}
                    handleCloseModal={props.handleCloseModal}
                    title={props.heading + " Details"}
                >
                    {props.modalContent}
                </BasicModal>
            </div>

            {props.vcards}
            {props.des}
        </div>
    );
};

export default VehiclePagecard5;
